import React from "react";
import { createUseStyles } from "react-jss";

import { IonText, IonButton } from "@ionic/react";

import { useHistory } from "react-router-dom";

import ContactSendIcon from "../../assets/pages/contact-send.svg";

const useStyles = createUseStyles({
  contactSend: {
    paddingTop: "1rem",
  },
  img: {
    width: 100,
    margin: "20px auto",
    display: "flex",
  },
  text: {
    textAlign: "center",
  },
  button: {
    margin: "0 auto",
    display: "flex",
    width: "90%",
  },
});

export const ContactSend: React.FC<{}> = () => {
  const classes = useStyles();
  const { goBack } = useHistory();
  return (
    <div className={classes.contactSend}>
      <img
        className={classes.img}
        src={ContactSendIcon}
        alt="Email enviando!"
      />
      <IonText>
        <p className={classes.text}>
          Acabos de enviar um <b>E-mail</b> com as instruções.
        </p>
      </IonText>

      <IonButton className={classes.button} onClick={goBack}>
        Voltar
      </IonButton>
    </div>
  );
};
